// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"1b3ed90b","147":"9fe9b391","156":"097d0179","438":"39bbd81a","706":"b8647504","726":"24d96d78"}[chunkId] + ".chunk.js";
};